import { useState } from "react";
import { masterSupabase } from "../lib/supabase.js";

const iS = { width: "100%", padding: "10px 14px", marginBottom: 12, background: "#06060a", border: "1px solid #1f1f3a", borderRadius: 8, color: "#e0e0e0", fontSize: 14, outline: "none", boxSizing: "border-box", fontFamily: "inherit" };

export default function SetPassword({ onComplete }) {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    if (password !== confirm) { setError("Passwords don't match."); return; }
    setLoading(true);
    const { error } = await masterSupabase.auth.updateUser({ password });
    if (error) { setError(error.message); setLoading(false); return; }
    onComplete?.();
  };

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", minHeight: "100vh", background: "#08080c" }}>
      <div style={{ width: 380, padding: 36, background: "#0d0d12", borderRadius: 16, border: "1px solid #1f1f3a" }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 4, color: "#e0e0e0" }}>Welcome to Clarifico AI</h1>
        <p style={{ fontSize: 13, color: "#888", marginBottom: 8 }}>Set a password to secure your account</p>
        <p style={{ fontSize: 12, color: "#555", marginBottom: 24, lineHeight: 1.5 }}>You'll use this password to sign in next time. Choose something you'll remember.</p>
        <form onSubmit={handleSubmit}>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="New password (min 8 characters)" style={iS} autoFocus />
          <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} placeholder="Confirm password" style={iS} />
          {error && <p style={{ color: "#f87171", fontSize: 12, marginBottom: 12 }}>{error}</p>}
          <button type="submit" disabled={loading} style={{ width: "100%", padding: "10px 0", background: "linear-gradient(135deg, #6366f1, #4f46e5)", border: "none", borderRadius: 8, color: "#fff", fontSize: 14, fontWeight: 600, cursor: "pointer", fontFamily: "inherit" }}>{loading ? "Setting password..." : "Set Password & Continue"}</button>
        </form>
      </div>
    </div>
  );
}
